import React, { useRef } from 'react';
import { List, Circle, Typography, Div } from '@icecreamsocial/components';
import { GiftCardIcon, ShareIcon, UnlockIcon } from '../SupportedIcons';

export const OfferExplanation = ({ link, onCopy, label, ...rest }) => {
	return (
		<Div
			backgroundColor="ambientLight"
			borderColor="ambient"
			borderTop="1px solid"
			padding="xlg"
			textAlign="center"
		>
			<Typography.H2 typoSize="md" marginBottom="md">
				How it Works
			</Typography.H2>
			<List
				bullets="none"
				display="flex"
				elWidth="100%"
				justifyContent="center"
				typoWeight="500"
				style={{ gap: '16px' }}
			>
				<List.Item>
					<Circle
						margin="auto"
						backgroundColor="ambient"
						textColor="accent"
						elWidth="48px"
						elHeight="48px"
					>
						<ShareIcon size={30} />
					</Circle>
					<Typography.P>
						Duis sunt veniam non sunt id eiusmod ut magna velit.
					</Typography.P>
				</List.Item>
				<List.Item>
					<Circle
						margin="auto"
						backgroundColor="ambient"
						textColor="accent"
						elWidth="48px"
						elHeight="48px"
					>
						<UnlockIcon size={30} />
					</Circle>
					<Typography.P>
						Duis sunt veniam non sunt id eiusmod ut magna velit.
					</Typography.P>
				</List.Item>
				<List.Item>
					<Circle
						margin="auto"
						backgroundColor="ambient"
						textColor="accent"
						elWidth="48px"
						elHeight="48px"
					>
						<GiftCardIcon size={30} />
					</Circle>
					<Typography.P>
						Duis sunt veniam non sunt id eiusmod ut magna velit.
					</Typography.P>
				</List.Item>
			</List>
		</Div>
	);
};
